<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    persistent
    width="500"
    transition="dialog-bottom-transition"
  >
    <v-card v-if="deliveryData!=null">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>เรียกพนักงาน Lalamove</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text style="height: 640px;">
        <v-container fluid>
          <div>
            <div style="display:none;">{{delivery}}</div>
            <h4 class="mx-4 mb-3">เส้นทางจัดส่ง</h4>
            <el-timeline>
              <el-timeline-item v-for="(stop, index) in stops" :key="index" :size="`large`">
                <strong class="deep-orange--text">{{stop.addresses.en_TH.displayString}}</strong>
                <br />
                {{stop.contact.name}} | {{stop.contact.mobile}}
              </el-timeline-item>
            </el-timeline>
            <!--
            <h4 class="mx-4">เวลารับสินค้า</h4>
            <div class="mx-4">{{new Date(deliveryData.datetimeReceived)}}</div>
            -->
          </div>
          <div class="ma-4 text-xs-left">
            <h4 class="my-2">บริการเสริม</h4>
            <div>
              <el-checkbox :disabled="true" v-model="services.lalabag" label="Food Box (Free)"></el-checkbox>
            </div>
            <div>
              <el-checkbox :disabled="true" v-model="services.tier_1" label="Purchase T1 (+25THB)"></el-checkbox>
            </div>
            <div>
              <el-checkbox :disabled="true" v-model="services.tier_2" label="Purchase T2 (+30THB)"></el-checkbox>
            </div>
          </div>
          <div>
            <el-input
              type="textarea"
              :disabled="true"
              :autosize="{ minRows: 4, maxRows: 4}"
              placeholder="Remark to Driver"
              v-model="remark"
            ></el-input>
          </div>
          <v-divider class="my-3"></v-divider>
          <template v-if="requestData!=null">
            <v-layout>
              <v-flex>
                <h3 class="subtitle font-weight-bold">เวลาคนขับมาถึง</h3>
                {{scheduleAt}}
                <!--
                <el-button type="text">Change</el-button>
                -->
              </v-flex>
              <v-flex class="text-xs-right">
                <h3 class="headline font-weight-bold">ราคา : ฿ {{deliveryFee}}</h3>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="isError">
            <div class="mt-3">
              <el-alert :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
            </div>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <el-button
          v-if="requestData!=null && !isPass"
          type="primary"
          class="el-btn-full"
          :loading="loading"
          @click="requestDriver"
        >เรียกรถ Lalamove</el-button>
        <el-button v-else type="primary" :disabled="true" class="el-btn-full">Loading...</el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";
import moment from "moment";
import { monthList } from "../utils/Constants";

export default {
  name: "driver-dialog",
  props: {
    showDialog: { default: false },
    deliveryData: { default: null },
    order: { default: null },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      errorMessage: "",
      stops: [],
      deliveryFee: 0,
      scheduleAt: null,
      requestData: null,
      remark: "",
      services: { lalabag: true, tier_1: false, tier_2: false },
    };
  },
  computed: {
    delivery: {
      get() {
        if (this.deliveryData != null) {
          let now = new Date();
          let shop = {
            name: this.order.shop.name,
            mobile: this.order.shop.contacts.find((x) => x.type == "mobile")
              .value,
          };
          let recipient = {
            name: this.order.user_ref_json.firstname,
            mobile: this.order.user_ref_json.mobile,
          };

          this.stops = [];
          this.deliveryFee = 0;
          this.scheduleAt = null;
          this.requestData = null;

          let from = {
            location: {
              lat: this.deliveryData.deliveryInfo.whereFrom.latitude.toString(),
              lng: this.deliveryData.deliveryInfo.whereFrom.longitude.toString(),
            },
            addresses: {
              en_TH: {
                displayString: this.deliveryData.deliveryInfo.whereFrom
                  .formatted_address,
                country: "TH",
              },
            },
            contact: {
              name: shop.name,
              mobile: shop.mobile,
            },
          };
          let displayString;

          //console.log(this.deliveryData);
          if (this.deliveryData.deliveryInfo.whereTo.name) {
            displayString = this.deliveryData.deliveryInfo.whereTo.name;
          } else {
            displayString = this.deliveryData.deliveryInfo.whereTo.address;
          }
          let to = {
            location: {
              lat: this.deliveryData.deliveryInfo.whereTo.lat.toString(),
              lng: this.deliveryData.deliveryInfo.whereTo.lng.toString(),
            },
            addresses: {
              en_TH: {
                displayString: displayString,
                country: "TH",
              },
            },
            contact: {
              name: recipient.name,
              mobile: recipient.mobile,
            },
          };

          this.stops.push(from);
          this.stops.push(to);

          let basket = "";
          let totalAmount = parseInt(
            this.order.amount.food +
              this.order.amount.delivery +
              this.order.amount.extra
          );
          let lalamoveFee = parseInt(
            this.order.amount.delivery + this.order.amount.extra
          );

          this.order.order_basket.product_list.map((item) => {
            basket += "  - " + item.name + " (x" + item.quantity + ")\n";
          });

          let ent_code = "HLZ";
          Service.Shop.get(this.order.shop.shop_id).then((res) => {
            ent_code = res.data.enterprise.ent_code;

            if (this.order.payment_type == "cash") {
              this.remark =
                "[" +
                ent_code +
                " #" +
                this.deliveryData.orderId +
                "] " +
                shop.name +
                "\n" +
                basket +
                "\nสั่งอาหารหน้าร้าน หรือโทร. " +
                shop.mobile +
                "\nค่าอาหาร ฿" +
                this.order.amount.food +
                " / ค่าจัดส่ง ฿" +
                lalamoveFee +
                "\n**เก็บเงินลูกค้า ฿" +
                totalAmount;
            } else {
              this.remark =
                "[" +
                ent_code +
                " #" +
                this.deliveryData.orderId +
                "] รับอาหารจากร้าน " +
                this.order.shop.name +
                "\nและนำไปส่ง\n\nแจ้งเลขที่ออเดอร์นี้ที่ร้านอาหาร";
            }
          });

          /*
             +
            this.deliveryData.deliveryInfo.whereFrom.name +
            " ไปส่งให้คุณ " +
            this.deliveryData.recipientInfo.firstname +
            " (โทร. " +
            this.deliveryData.recipientInfo.mobile +
            ")"
          */

          let special_requests = ["LALABAG"];

          if (this.order.payment_type == "cash") {
            if (this.order.amount.food <= 1000) {
              special_requests.push("HELP_BUY");
              this.services.tier_1 = true;
            } else {
              special_requests.push("PURCHASE_SERVICE_TIER_2");
              this.services.tier_2 = true;
            }
          }

          let paymentMethod = "CASH";

          if (this.order.payment_type != "cash") {
            paymentMethod = "WALLET";
          }

          let schedule_at = this.deliveryData.datetimeReceived;
          if (this.order.cluster_id != null) {
            schedule_at = moment(this.order.datetime_received);
            schedule_at = schedule_at
              .subtract(30, "minutes")
              .format("YYYY-MM-DD HH:mm");
          }
          let data = {
            schedule_at: schedule_at,
            special_requests: special_requests,
            stops: this.stops,
            remarks: this.remark,
            paymentMethod: paymentMethod,
            shop_id: parseInt(this.order.shop_id),
            basket: this.order.order_basket.product_list,
            promocode: { value: "" },
          };

          //console.log(new Date(now + 30 * 60000));
          if (
            new Date(this.deliveryData.datetimeReceived) <
            new Date(now + 30 * 60000)
          ) {
            console.log("passed!");
            let asapDate = new Date(new Date().getTime() + 30 * 60000);
            data.schedule_at = "asap";
          }

          console.log(JSON.stringify(data.schedule_at));

          Service.Delivery.getDeliveryFee(data)
            .then((res) => {
              if (res.success) {
                let date = new Date(res.data.scheduleAt);
                this.scheduleAt =
                  date.getDate() +
                  " " +
                  monthList[date.getMonth()] +
                  " " +
                  date.getFullYear() +
                  " " +
                  this.pad(date.getHours()) +
                  ":" +
                  this.pad(date.getMinutes());
                //this.deliveryFee = res.data.quotedTotalFee.amount;
                this.deliveryFee =
                  parseFloat(this.order.amount.delivery) +
                  parseFloat(this.order.amount.delivery_tax);
                this.requestData = res.data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
        return this.deliveryData;
      },
      set(value) {
        // If close dialog.
        if (!value) {
        }
      },
    },
  },
  mounted() {},
  methods: {
    requestDriver() {
      this.loading = true;
      this.requestData = { ...this.requestData, remarks: this.remark };

      console.log(JSON.stringify(this.requestData));
      Service.Order.requestDriver(this.deliveryData.orderId, this.requestData)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.$emit("save", res.data);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isError = true;
          if (err.message == "This order already has driver.") {
            this.errorMessage =
              "ไม่สามารถเรียกรถ Lalalmove ได้เนื่องจากออเดอร์ได้เรียกรถไปแล้ว กรุณาติดต่อเจ้าหน้าที่";
          }
          console.log(err);
        });
    },
    close() {
      this.isError = false;
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.form);
    },
    pad(n) {
      return n < 10 ? "0" + n : n;
    },
  },
};
</script>
